import restCrudActions from '../../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'contact',
    pluginName: 'CONTACT',
    entityName: 'CONTACT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch Contact action creators
export const fetchContactInit = () => { return crudActions.fetchInit(); }
export const fetchContactStart = () => { return crudActions.fetchStart(); }
export const fetchContactSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchContactFail = () => { return crudActions.fetchFail(); }

export const fetchContactsCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchContactStart());
        try {
            let countRes = await rest.post("contact/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchContactSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchContactFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch contact."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchContactFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch contact."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchContacts = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchContactStart());
        try {
            let listRes = await rest.post("contact/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchContactSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchContactFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchContactFail());

            return { data: [] };
        }
    }
};

// Create Contact  action creators
export const createContactInit = () => { return crudActions.createInit(); };
export const createContactStart = () => { return crudActions.createStart(); };
export const createContactSuccess = createdContact => { return crudActions.createSuccess(createdContact); };
export const createContactFail = error => { return crudActions.createFail(error); };
export const createContact = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createContactStart());
        try {
            let res = await rest.post('/contact/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created contact.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createContactFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create contact."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create contact."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createContactFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Contact  action creators
export const bulkDeleteContactInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteContactStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteContactSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteContactFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteContact = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteContactStart());
        try {
            let res = await rest.post('/contact/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteContactSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted contact.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteContactFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete contact."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete contact."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteContactFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit contact  action creators
export const editContactInit = () => { return crudActions.editInit(); };
export const editContactStart = () => { return crudActions.editStart(); };
export const editContactSuccess = editedContact => { return crudActions.editSuccess(editedContact); };
export const editContactFail = error => { return crudActions.editFail(error); };

export const editContact = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editContactStart());
        try {
            let res = await rest.post('/contact/save', params);
            if (res.data && res.data.succeeded) {
                // dispatch(editContactSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated contact.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editContactFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit contact."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit contact."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editContactFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load contact action creators
export const loadContactInit = () => { return crudActions.loadInit(); };
export const loadContactStart = () => { return crudActions.loadStart(); };
export const loadContactSuccess = loadedContact => { return crudActions.loadSuccess(loadedContact); };
export const loadContactFail = error => { return crudActions.loadFail(error); };
export const loadContact = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

